module.exports = __webpack_public_path__ + "img/face.1424b05a.svg";